import { initGlobalEDebug } from '@/lib/globalEDebug';

if (typeof window !== 'undefined') {
  initGlobalEDebug();
}
